import {SizeMe} from 'react-sizeme'
import {Root, classes, StyledTypography} from './ChartContainerStyle'
import Typography from '@mui/material/Typography'
import MultilineChart from '@mui/icons-material/MultilineChart'
import CustomBox from '../common/CustomBox'
import PropTypes from 'prop-types'

const ChartContainer = ({title, chart: Chart, chartName, isAdminPanelOpen, ...rest}) => {
  return (
    <Root
      elevation={2}
      chartName={chartName}
      tabIndex={Boolean(Chart) && chartName === 'PopulationDistributionChart' ? 0 : ''}
    >
      {title && (
        <CustomBox
          aria-label='interactive-bar-chart-displaying-the-distribution-of-the-selected-population-by-different-filters'
          component='span'
          className={classes.titleContainer}
        >
          <Typography sx={{borderSizing: 'border-box'}} component='span' color='primary' className={classes.title}>
            {title}
          </Typography>
        </CustomBox>
      )}
      {!Chart && (
        <CustomBox display='flex' flexDirection='column' alignItems='center'>
          <MultilineChart classes={{colorPrimary: classes.icon}} color='primary' />
          <Typography variant='h6' component='h2' className={classes.loadDataBoxAction}>
            Load Data Snapshot to view data
          </Typography>
        </CustomBox>
      )}
      {Boolean(Chart) && (
        <SizeMe monitorHeight>
          {({size: {width, height}}) => {
            return (
              <div style={{position: 'relative', height: '100%'}}>
                <div style={{position: 'absolute', width, height}}>
                  <Chart {...rest} width={width} height={height} isAdminPanelOpen={isAdminPanelOpen} />
                </div>
              </div>
            )
          }}
        </SizeMe>
      )}
      {Boolean(Chart) && chartName === 'PopulationDistributionChart' && (
        <StyledTypography variant='caption' aria-hidden='true'>
          *All insights estimate selected Adult populations with elevated health risks, based on a combination of raw
          data and predictive models
        </StyledTypography>
      )}
    </Root>
  )
}

ChartContainer.propTypes = {
  title: PropTypes.object,
  chart: PropTypes.func.isRequired,
  chartName: PropTypes.string.isRequired,
  isAdminPanelOpen: PropTypes.bool
}

ChartContainer.propTypes = {
  title: PropTypes.string,
  chart: PropTypes.elementType,
  chartName: PropTypes.string,
  isAdminPanelOpen: PropTypes.bool
}

export default ChartContainer

/**
 * Renders a container for a chart with optional title and additional information.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.title] - The title of the chart.
 * @param {React.ElementType} props.chart - The chart component to render.
 * @param {string} props.chartName - The name of the chart.
 * @param {boolean} [props.isAdminPanelOpen] - Indicates if the admin panel is open.
 * @param {...Object} rest - Additional props to pass to the chart component.
 * @returns {JSX.Element} The rendered ChartContainer component.
 */
